import { Dialog, useMediaQuery, useTheme } from '@mui/material';

/**
 * ResponsiveDialog Component
 * Automatically switches to fullscreen mode on mobile devices (< sm breakpoint)
 *
 * Usage:
 * <ResponsiveDialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
 *   <DialogTitle>...</DialogTitle>
 *   <DialogContent>...</DialogContent>
 *   <DialogActions>...</DialogActions>
 * </ResponsiveDialog>
 */
const ResponsiveDialog = ({ children, ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      fullScreen={isMobile}
      {...props}
    >
      {children}
    </Dialog>
  );
};

export default ResponsiveDialog;
